/**
 * MaskSelector component.
 */
import AccessBackground from './accessBackground';
import DetailBackground from './detailBackground';
import MainBackground from './mainBackground';
import Pages from '@shared/types/enums/pages';
import { routerSelector } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useMemo } from 'react';

/**
 * Selects the appropriate mask based on the current page.
 */
export default function BackgroundSelector() {
  // ------------------------------------------------------------
  // Variables
  // ------------------------------------------------------------

  const {
    route: { Page },
  } = useAppSelector(routerSelector);

  // ------------------------------------------------------------
  // Memoization
  // ------------------------------------------------------------

  const Background = useMemo(() => {
    switch (Page) {
      case Pages.PLAYER:
      case Pages.ZAPPER:
        return () => <></>;
      case Pages.DETAIL:
      case Pages.DETAIL_ADDON:
        return DetailBackground;
      case Pages.LANGUAGES:
      case Pages.LINK:
      case Pages.SUCCESSFUL_LINK:
      case Pages.WELCOME:
        return AccessBackground;
      default:
        return MainBackground;
    }
  }, [Page]);

  // ------------------------------------------------------------
  // Render
  // ------------------------------------------------------------

  return <Background />;
}
